var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useContext, useEffect, useState } from "react";
import { Form } from "react-formio";
import formatFormioJSON from "../../utils/FormatFormioJSON";
import handleCustomEvent from "../../utils/HandleCustomEvent";
import { ModalPicker } from "../common/ModalPicker";
import FormContext from "../../contexts/formContext/form-context";
import SubmissionContext from "../../contexts/submissionContext/submission-context";
import FormState from "../../contexts/formContext/FormState";
import SubmissionState from "../../contexts/submissionContext/SubmissionState";
import ToastMessage from "../common/ToastMessage";
import { submissionGETdata, submissionPOSTdata, submissionPUTdata, } from "../../services/SubmissionService";
import { uploadDocument, deleteDocument, downloadDocument, } from "../../services/DocumentService";
var TsfFormioForm = function (props) {
    var _a = useState({}), submissionData = _a[0], setSubmissionData = _a[1];
    var form = props.form;
    useEffect(function () {
        if (form && form.properties !== null) {
            var _a = form.properties, isInit = _a.isInit, requestType = _a.requestType, endpoint = _a.endpoint, requestBody = _a.requestBody;
            if (form && form.properties && isInit && requestType === "get") {
                submissionGETdata(endpoint, setSubmissionData);
            }
            else if (isInit && requestType === "post") {
                submissionPOSTdata(endpoint, setSubmissionData, requestBody);
            }
            else if (isInit && requestType === "put") {
                submissionPUTdata(endpoint, setSubmissionData, requestBody);
            }
        }
    }, [form]);
    return (React.createElement(SubmissionState, null,
        React.createElement(FormState, null,
            React.createElement(FormioForm, __assign({ submission: submissionData }, props)))));
};
var FormioForm = function (props) {
    var form = props.form, submission = props.submission, onCustomEvent = props.onCustomEvent, ref = props.ref, other = __rest(props, ["form", "submission", "onCustomEvent", "ref"]);
    var customForm = form;
    var _a = useContext(FormContext), formioForm = _a.form, updateForm = _a.updateForm;
    var _b = useContext(SubmissionContext), submissionData = _b.submission, updateSubmission = _b.updateSubmission, resetSubmission = _b.resetSubmission;
    useEffect(function () {
        if (formioForm !== form) {
            resetSubmission();
        }
    }, [form]);
    useEffect(function () {
        if (submission === null || submission === void 0 ? void 0 : submission.data) {
            updateSubmission(submission.data);
        }
        updateForm(customForm);
    }, [customForm, submission]);
    var FileService = /** @class */ (function () {
        function FileService() {
        }
        FileService.prototype.uploadFile = function (storage, file, fileName, dir, evt, url, options, fileKey) {
            return __awaiter(this, void 0, void 0, function () {
                var _this = this;
                return __generator(this, function (_a) {
                    console.log("upload action");
                    console.log(url);
                    return [2 /*return*/, new Promise(function (resolve, reject) { return __awaiter(_this, void 0, void 0, function () {
                            var res;
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        console.log(storage, file, fileName, dir, evt, url, options, fileKey);
                                        return [4 /*yield*/, uploadDocument(url, {
                                                file: file,
                                                documentPath: dir,
                                                name: file.name,
                                            })];
                                    case 1:
                                        res = _a.sent();
                                        console.log(res.data.id);
                                        if (res.success) {
                                            // this.loadImage({ name: file.name, url: '', data: res.data, file });
                                            return [2 /*return*/, resolve({
                                                    storage: "url",
                                                    name: file.name,
                                                    url: "",
                                                    size: file.size,
                                                    type: file.type,
                                                    file: file,
                                                    data: res.data,
                                                })];
                                        }
                                        else {
                                            reject("Falied to upload");
                                        }
                                        return [2 /*return*/];
                                }
                            });
                        }); })];
                });
            });
        };
        FileService.prototype.deleteFile = function (fileInfo) {
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    console.log(fileInfo);
                    deleteDocument(fileInfo.data);
                    return [2 /*return*/];
                });
            });
        };
        FileService.prototype.downloadFile = function (fileInfo, options) {
            return __awaiter(this, void 0, void 0, function () {
                var response;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            console.log(fileInfo);
                            return [4 /*yield*/, downloadDocument(fileInfo.data.id)];
                        case 1:
                            response = _a.sent();
                            // console.log(response.data);
                            if (fileInfo.type.includes("image")) {
                                return [2 /*return*/, {
                                        url: "https://cdn-icons-png.flaticon.com/512/6789/6789174.png",
                                        name: fileInfo.name,
                                    }];
                            }
                            else if (fileInfo.type.includes("pdf")) {
                                return [2 /*return*/, {
                                        url: "https://cdn.pixabay.com/photo/2017/03/08/21/20/pdf-2127829_960_720.png",
                                        name: fileInfo.name,
                                    }];
                            }
                            else {
                                return [2 /*return*/, {
                                        url: "https://cdn.pixabay.com/photo/2017/03/08/21/19/file-2127825_960_720.png",
                                        name: fileInfo.name,
                                    }];
                            }
                            return [2 /*return*/];
                    }
                });
            });
        };
        FileService.prototype.loadImage = function (fileInfo) {
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    return [2 /*return*/, this.downloadFile(fileInfo, {}).then(function (result) { return ({
                            src: fileInfo.file,
                            name: fileInfo.name,
                            id: fileInfo.data,
                        }); })];
                });
            });
        };
        return FileService;
    }());
    var myOptions = {
        fileService: new FileService(),
    };
    return (React.createElement("div", null,
        React.createElement(Form, __assign({ form: formatFormioJSON(formioForm === null || formioForm === void 0 ? void 0 : formioForm.components), submission: submissionData, options: myOptions, ref: ref, 
            // onChange={({ data, changed }) => {
            //   if (changed) {
            //     updateSubmission(data);
            //   }
            // }}
            onCustomEvent: function (event) {
                handleCustomEvent(event, customForm, onCustomEvent, updateSubmission);
            } }, other, { onChange: function (schema) {
                console.log(schema);
            } })),
        React.createElement(ModalPicker, null),
        React.createElement(ToastMessage, null)));
};
export default TsfFormioForm;
//# sourceMappingURL=index.js.map